export default "__VITE_ASSET__CXNTKn0z__"